import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit {


  is_user_signed : boolean = false;
  route ;

  constructor(
    private router: Router,
    private cookie_s: CookieService
  ) { }

  ngOnInit(): void {
    this.router.events.subscribe({
      next: (event) => {
        if (event instanceof NavigationEnd) {
          this.route = event.url;
        }
      },
    });
  }




  is_signed_in()
  {
    
    if ( this.cookie_s.get('token') )
    {
      this.is_user_signed = true;
      return true;
    }
    else
    {
      this.is_user_signed = false;
      return false;
    }

  }



  btn_clicked()
  {


    if ( this.is_user_signed )
    {

      // sign out
      this.sign_out();
    
    }
    else
    {

      // redirect to sign-in
      this.router.navigate(['auth' , 'sign-in']);

    }

  }



  sign_out()
  {

    // remove saved data
    this.cookie_s.delete('token');
    this.cookie_s.delete('user');

    // redirect to home
    this.router.navigateByUrl('/');

  }



  toggle_mobile_nav(mobile_nav_btn : any)
  {

    if ( window.innerWidth < 1000 )
    {
      mobile_nav_btn.click();
    }
  }

  changeLanguage() {
    if (this.cookie_s.get('lang') === 'en') {
      this.cookie_s.set("lang", "ar", undefined, "/");
      location.reload();
    } else {
      this.cookie_s.set("lang", "en", undefined, "/");
      location.reload();
    }
  }



  // stupid way, change tis later
  check_home_page() : boolean
  {

    if ( document.location.pathname == '/home' )
    {
      return true;
    }
    else
    {
      return false;
    }


  }
  



}
